import { render, staticRenderFns } from "./MessageSendNotification.vue?vue&type=template&id=5bf7d42b&"
import script from "./MessageSendNotification.vue?vue&type=script&setup=true&lang=js&"
export * from "./MessageSendNotification.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports